import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useRef } from "react";
import react_countdown from "react-countdown";
import classnames from "classnames";
import { pluralize } from "../../format/index.js";
import RedoCountdown_styles from "./RedoCountdown.styles.js";
const RedoCountdown = (t0)=>{
    const $ = c(17);
    const { label, disabled, finalDate, toggleTimerVisibility } = t0;
    const { classes } = RedoCountdown_styles();
    const counterRef = useRef(null);
    const pluralizeSeconds = _temp;
    let t1;
    let t2;
    if ($[0] !== disabled) {
        t1 = ()=>{
            var _counterRef_current;
            const isStarted = !!(null == (_counterRef_current = counterRef.current) ? void 0 : _counterRef_current.isStarted());
            let timer;
            if (!isStarted && !disabled) timer = setTimeout(()=>{
                var _counterRef_current;
                null == (_counterRef_current = counterRef.current) || _counterRef_current.start();
            });
            if (isStarted && disabled) {
                var _counterRef_current1;
                null == (_counterRef_current1 = counterRef.current) || _counterRef_current1.pause();
            }
            return ()=>{
                clearTimeout(timer);
            };
        };
        t2 = [
            disabled
        ];
        $[0] = disabled;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    useEffect(t1, t2);
    let t3;
    if ($[3] !== classes.label || $[4] !== label) {
        t3 = /*#__PURE__*/ jsxs("div", {
            className: classes.label,
            children: [
                label,
                " через:"
            ]
        });
        $[3] = classes.label;
        $[4] = label;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== classes.countdown || $[7] !== classes.countdownDisabled || $[8] !== disabled) {
        t4 = (t5)=>{
            const { seconds } = t5;
            return /*#__PURE__*/ jsx("div", {
                className: classnames(classes.countdown, disabled && classes.countdownDisabled, "aqa_redo_countdown"),
                children: pluralizeSeconds(seconds)
            });
        };
        $[6] = classes.countdown;
        $[7] = classes.countdownDisabled;
        $[8] = disabled;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== finalDate || $[11] !== t4 || $[12] !== toggleTimerVisibility) {
        t5 = /*#__PURE__*/ jsx(react_countdown, {
            date: finalDate,
            autoStart: false,
            onComplete: toggleTimerVisibility,
            ref: counterRef,
            renderer: t4
        }, finalDate);
        $[10] = finalDate;
        $[11] = t4;
        $[12] = toggleTimerVisibility;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t3 || $[15] !== t5) {
        t6 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t3,
                t5
            ]
        });
        $[14] = t3;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
};
function _temp(count) {
    return pluralize(count, [
        "\u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        "\u0441\u0435\u043A\u0443\u043D\u0434\u044B",
        "\u0441\u0435\u043A\u0443\u043D\u0434"
    ], {
        withZeroPad: true
    });
}
export { RedoCountdown };
